<template>
  <div class="container">
    <b-modal no-close-on-backdrop centered ref="modal-confirm-mail" hide-footer id="modal-confirm-mail">
      <h4 class="text-center">
        ¿Está seguro de validar la Liga de Pago? El cliente será notificado vía email.
      </h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-mail')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="processPago()">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-pagado" hide-footer id="modal-confirm-pagado">
      <h4 class="text-center">
        ¿Está seguro de validar el pago?
      </h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-pagado')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="processPagado()">OK</b-button>
    </b-modal>

    <h4 class="cardD">Pago Complementario</h4>
    <div class="mt-4">
      <ValidationProvider name="liga_pago" rules="required" v-slot="{ errors }" :custom-messages="{
        required: 'La liga de pago es requerida',
      }">
        <b-form-group label="Liga de pago Openpay" label-for="input-link-pago-complementario">
          <b-input-group class="mt-3">
            <b-input-group-append>
              <b-button :variant="isTextCopied ? 'success' : 'secondary'" squared v-b-tooltip.hover title="Copiar"
                @click="copyLinkToClipboard">
                <b-icon v-if="isTextCopied" icon="check"></b-icon>
                <b-icon v-else icon="clipboard"></b-icon>
              </b-button>
            </b-input-group-append>
            <b-form-input id="input-link-pago-complementario" v-model="ratificacion.liga_pago_complementario"
              :disabled="ratificacion.estatus_id >= 50 && !ratificacion.staff"
              placeholder="Link Openpay"></b-form-input>
          </b-input-group>
        </b-form-group>

        <!-- <base-input type="text" label="Liga de pago Openpay" placeholder=""
          v-model="ratificacion.liga_pago_complementario"
          :disabled="ratificacion.estatus_id >= 50 && !ratificacion.staff">
        </base-input> -->
        <span class="cardErrors">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <div class="mt-4" v-if="ratificacion.staff">
      <div class="">
        <b-button class="btn-fill orange-btn bottom2" size="m" @click="openConfirmPagoModal()"
          :disabled="ratificacion.cotizaciones_id_complementario != null">Validar</b-button>
      </div>
    </div>

    <div class="mt-4" v-if="ratificacion.staff">
      <div class="">
        <b-button class="btn-fill green-btn bottom2" size="m" @click="openConfirmPagadoModal()"
          :disabled="ratificacion.estatus_id != 50 || ratificacion.cotizaciones_id_complementario == null">Pagado</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { CotizacionesApi, FuncionesApi, LayoutsApi } from "@/api";

export default ({
  name: "PagoComplementario",

  props: {
    ratificacion: { type: Object }
  },

  data() {
    return {
      isTextCopied: false
    }
  },

  methods: {
    copyLinkToClipboard() {
      if (!this.ratificacion.liga_pago_complementario) {
        return;
      }

      navigator.clipboard
        .writeText(this.ratificacion.liga_pago_complementario)
        .then(this.isTextCopied = true);
    },

    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    openConfirmPagoModal() {
      if (!this.ratificacion.liga_pago_complementario) {
        this.showErrorToast('Por favor ingrese una liga de pago.');
        return;
      }
      this.$refs["modal-confirm-mail"].show();
    },

    openConfirmPagadoModal() {
      this.$refs["modal-confirm-pagado"].show();
    },


    processPago() {
      this.$refs["modal-confirm-mail"].hide();
      this.loading = true;
      this.createCotizacionComplementaria()
        .then(() => this.sendMailPagoComplementario())
        .then(() => this.submitPagoComplementario())
        .catch((error) => {
          this.showErrorToast('Sucedió un error, intente más tarde');
          console.log(error);
        })
        .finally(() => { this.loading = false; })
    },

    async createCotizacionComplementaria() {
      const { id } = await CotizacionesApi.create({
        liga_pago: this.ratificacion.liga_pago_complementario,
        activo: 1
      });

      this.ratificacion.cotizaciones_id_complementario = id;
    },

    processPagado() {
      this.$refs["modal-confirm-pagado"].hide();
      this.$emit('pagadoComplementario');
    },

    async sendMailPagoComplementario() {
      const solicitante_o_representante = this.ratificacion.ratificantes.find(obj => obj.persona == 'Física');
      const email = solicitante_o_representante.email;
      const layout = await LayoutsApi.detail(25);

      layout.body = layout.body.replace('{liga_pago}', this.ratificacion.liga_pago_complementario);

      await FuncionesApi.sendMail({
        emailTo: email,
        body: layout.body,
        subject: layout.subject
      });

      this.$toast.success('Se ha notificado al cliente correctamente.', {
        timeout: 40000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    submitPagoComplementario() {
      this.$emit('allChecksPassed');
    }
  }
})
</script>
